module.exports = __webpack_public_path__ + "img/banner-fr.cf107921.png";